export const GRAPHQL_URI = process.env.REACT_APP_GRAPHQL_URI
export const MQTT_URI = 'wss://iot.eclipse.org:443/mqtt'
export const AUTH_TOKEN_KEY = 'luna.auth.token'
export const CURRENT_HOUSE_KEY = 'luna.house.current'



// WEBPACK FOOTER //
// ./src/constants.js